import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ContactService } from 'src/app/rest_services/contact.service';
import { DashboardService } from 'src/app/rest_services/dashboard.service';
import { MsSectorService } from 'src/app/rest_services/ms-sector.service';
import { SurveyService } from 'src/app/rest_services/msSurveyServices/survey.service';
import { SalesService } from 'src/app/rest_services/sales.service';
import { SettingsService } from 'src/app/rest_services/settings.service';
import { getUniqueId } from 'src/app/rest_services/utilFunctions/functions_utiles';
import { VisitService } from 'src/app/rest_services/visit.service';
import {v4 as uuidv4} from 'uuid';
import { phoneNumberValidator } from 'src/app/validators/phone-number.validator';

@Component({
  selector: 'app-complete-visit',
  templateUrl: './complete-visit.component.html',
  styleUrls: ['./complete-visit.component.css']
})
export class CompleteVisitComponent implements OnInit {

  msToken : any = '';
  id : any = '';
  toComplete : boolean = true;
  togenerateUuid:any=13;
  addedMsg:any ='';
  addError:any ='';
  imgWrap:any = "";
  imgArray:any[] = [];
  picturesVisit:any[]=[];
  picturesVisitUpdate:any[]=[];
  terminatedVisitForm:FormGroup;
  detail:any;
  perso:any;
  actions:any;
  terminer_plan:boolean=true;
  adaptedActions:any[]=[];
  sells:any[]=[];somme:any=0;
  successTerminatVisit:boolean=true;
  finalactions:any[]=[];

  customerContacts: any[] = [];
  @ViewChild('contactFullnameInput', { static: false }) contactFullnameInput!: ElementRef;

  salesSubscription!:Subscription;

  constructor(
    private visitService:VisitService,
    private msSector : MsSectorService,
    private route: ActivatedRoute,
    private fb:FormBuilder,
    private settingsService:SettingsService,
    private dashboardServiceservice:DashboardService,
    private msSurvey : SurveyService,
    private location : Location,
    private contactService : ContactService,
    private salesService: SalesService
  ) { 
    this.terminatedVisitForm = this.fb.group({
      'contact_fullname': ['', [Validators.required, Validators.minLength(5), this.noSpecialCharactersValidator()]],
      'contact_function' : [''],
      'contact_phone' : ['', [phoneNumberValidator()]],
      'contact_email' : ['', [Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]]
    });
  }
  noSpecialCharactersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const regex = /^[a-zA-Z ]+$/; 
      const valid = regex.test(control.value);
      return valid ? null : { 'invalidCharacters': true };
    };
  }
  surveyUuid :any;

  connectedComany:any;

  ngOnInit(): void {
    this.msToken = sessionStorage.getItem("msToken") || localStorage.getItem("msToken");

    if(localStorage.getItem("token")!=undefined) {
      this.APIToken = localStorage.getItem("token");
    }else if(sessionStorage.getItem("token")!=undefined){
      this.APIToken = sessionStorage.getItem("token");
    }
    let decodedJWT = JSON.parse(window.atob(this.APIToken.split('.')[1]));
    this.connectedComany = decodedJWT.company;
    this.id= this.route.snapshot.paramMap.get('cr')
    var fr= window.location.href.split( 'from');
    if(fr[1]!=undefined && fr.length>0){
      var from = fr[1].split(';')[0];      
      if(from=="Complete"){
        this.toComplete=true;
      } else{ 
        this.toComplete=false;  
      }
    }
    
    this.Detail(this.id);
    this.getConfig();
    var glob = this;

    $('body').on('click', ".upload__img-close", function (e:any) {
      const imgUrl = $(this).parent().css('background-image').replace(/^url\("data:image\/png;base64,|"?\)$/g, '');
      const index = glob.picturesVisit.findIndex(picUrl => picUrl === imgUrl);
      if (index !== -1) {
          glob.picturesVisit.splice(index, 1);
      }
      $(this).parent().parent().remove();
    });

    this.setupAutocomplete();
    this.getSalesVisit();
  }

  ngAfterViewInit(): void {
    // Initialiser l'autocomplete après que la vue soit chargée
    setTimeout(() => {
      this.initializeAutocomplete();
    }, 500);
  }

  setupAutocomplete() {
    // Charger les contacts une fois que les détails du client sont disponibles
    this.contactService.contactsSubject.subscribe(
      (data: any) => {
        if (data.code === 'f898fba515734ae7b269f99e100c061e' && data.contacts) {
          this.customerContacts = data.contacts.map((contact: any) => ({
            label: contact.fullName,
            value: contact.fullName,
            email: contact.mail,
            phone: contact.tel,
            function: contact.function
          }));
          
          this.initializeAutocomplete();
        }
      }
    );
  }

  loadCustomerContacts() {
    if (this.detail?.visit_customer_uuid) {
      this.contactService.getContactsByCustomerUuid(this.detail.visit_customer_uuid).subscribe(
        (response: any) => {
          if (response.code === 'f898fba515734ae7b269f99e100c061e' && response.contacts) {
            this.customerContacts = response.contacts.map((contact: any) => ({
              label: contact.fullName,
              value: contact.fullName,
              email: contact.mail,
              phone: contact.tel,
              function: contact.function
            }));
            
            this.initializeAutocomplete();
          }
        },
        (error: any) => {
          console.error('Erreur lors du chargement des contacts:', error);
        }
      );
    }
  }

  initializeAutocomplete() {
    const glob = this;
    
    if (this.customerContacts.length > 0) {
      // Détruire l'autocomplete existant s'il y en a un
      if ((<any>$("#contact_fullname")).autocomplete("instance")) {
        (<any>$("#contact_fullname")).autocomplete("destroy");
      }
      
      // Initialiser jQuery UI Autocomplete
      (<any>$("#contact_fullname")).autocomplete({
        source: function (request: any, response: any) {
          const term = request.term.toLowerCase();
          const filtered = glob.customerContacts.filter(contact => 
            contact.label.toLowerCase().includes(term) ||
            contact.function?.toLowerCase().includes(term)
          );
          response(filtered);
        },
        
        minLength: 2,
        delay: 300,
        
        focus: function(event: any, ui: any) {
          event.preventDefault();
          $("#contact_fullname").val(ui.item.label);
          return false;
        },
        
        select: function(event: any, ui: any) {
          event.preventDefault();
          
          // Mettre à jour le formulaire avec les informations du contact sélectionné
          glob.terminatedVisitForm.patchValue({
            contact_fullname: ui.item.value,
            contact_email: ui.item.email || '',
            contact_phone: ui.item.phone || '',
            contact_function: ui.item.function || ''
          });
          
          // Déclencher la validation
          glob.terminatedVisitForm.get('contact_fullname')?.markAsTouched();
          
          // FORCER LE LABEL À MONTER POUR TOUS LES CHAMPS
          setTimeout(() => {
            // Champ Nom complet
            const nameInput = document.getElementById('contact_fullname') as HTMLInputElement;
            if (nameInput) {
              nameInput.classList.add('is-dirty');
              const nameParent = nameInput.closest('.mdl-textfield');
              if (nameParent) nameParent.classList.add('is-dirty');
              nameInput.focus();
              setTimeout(() => nameInput.blur(), 10);
            }
            
            // Champ Fonction
            const funcInput = document.getElementById('contact_function') as HTMLInputElement;
            if (funcInput && ui.item.function) {
              funcInput.classList.add('is-dirty');
              const funcParent = funcInput.closest('.mdl-textfield');
              if (funcParent) funcParent.classList.add('is-dirty');
            }
            
            // Champ Téléphone
            const phoneInput = document.getElementById('contact_phone') as HTMLInputElement;
            if (phoneInput && ui.item.phone) {
              phoneInput.classList.add('is-dirty');
              const phoneParent = phoneInput.closest('.mdl-textfield');
              if (phoneParent) phoneParent.classList.add('is-dirty');
            }
            
            // Champ Email
            const emailInput = document.getElementById('contact_email') as HTMLInputElement;
            if (emailInput && ui.item.email) {
              emailInput.classList.add('is-dirty');
              const emailParent = emailInput.closest('.mdl-textfield');
              if (emailParent) emailParent.classList.add('is-dirty');
            }
          }, 50);
          
          return false;
        },
        
        // Personnaliser l'affichage des suggestions
        create: function() {
          $(this).data('ui-autocomplete')._renderItem = function(ul: any, item: any) {
            return $("<li>")
              .append(`
                <div class="autocomplete-item">
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <strong style="color: #2c3e50;">${item.label}</strong>
                    <small style="color: #7f8c8d;">${item.function || ''}</small>
                  </div>
                  <div class="d-flex justify-content-between">
                    ${item.email ? `<small style="color: #5d6d7e;"><i class="flaticon-mail mr-1"></i>${item.email}</small>` : ''}
                    ${item.phone ? `<small style="color: #5d6d7e;"><i class="flaticon-telephone ml-3 mr-1"></i>${item.phone}</small>` : ''}
                  </div>
                </div>
              `)
              .appendTo(ul);
          };
        }
      });
    }
  }

  isNewContact(): boolean {
    const formValues = this.terminatedVisitForm.value;
    
    // Si le formulaire n'est pas valide ou vide, ne pas afficher le message
    if (!formValues.contact_fullname || formValues.contact_fullname.trim() === '') {
        return false;
    }
    
    // Vérifier si c'est un contact existant dans le répertoire du client
    const isExistingContact = this.customerContacts.some(
        contact => contact.email === formValues.contact_email
    );
    
    // Si c'est un contact existant, pas besoin d'afficher le message
    if (isExistingContact) {
        return false;
    }
    
    // C'est un nouveau contact potentiel
    return true;
  }

  clearContactField() {
    this.terminatedVisitForm.patchValue({
      contact_fullname: '',
      contact_email: '',
      contact_phone: '',
      contact_function: ''
    });
    
    // Enlever la classe is-dirty
    setTimeout(() => {
      const fields = ['contact_fullname', 'contact_function', 'contact_phone', 'contact_email'];
      fields.forEach(fieldId => {
        const input = document.getElementById(fieldId) as HTMLInputElement;
        if (input) {
          input.classList.remove('is-dirty');
          const parent = input.closest('.mdl-textfield');
          if (parent) {
            parent.classList.remove('is-dirty');
            parent.classList.remove('is-focused');
          }
        }
      });
    }, 0);
  }

  fixMdlLabel(fieldId: string) {
    setTimeout(() => {
      const input = document.getElementById(fieldId) as HTMLInputElement;
      if (input) {
        // Ajouter la classe is-dirty directement sur l'input
        input.classList.add('is-dirty');
        
        // Forcer le parent à avoir la classe is-dirty
        const parent = input.closest('.mdl-textfield');
        if (parent) {
          parent.classList.add('is-dirty');
        }
        
        // Si l'input a une valeur, forcer le label à monter
        if (input.value && input.value.trim() !== '') {
          // Simuler un focus puis blur pour activer le label
          input.focus();
          setTimeout(() => {
            input.blur();
            // S'assurer que la classe is-dirty reste
            input.classList.add('is-dirty');
            if (parent) {
              parent.classList.add('is-dirty');
            }
          }, 10);
        }
      }
    }, 0);
  }

  config: any = {
    skypeVisibility: false,
    zipCodeVisibility: false
  };
  getConfig(){
    this.settingsService.getConfig().subscribe(
      (resp: any) => {
        if(resp.code == "45859d1ba9e878f62c51935e3119d7ad"){
          this.config.survey = resp.config.survey;
        }
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  createContactForCustomer(contactData: any): void {
    // Préparer les données du contact au format attendu par l'API
    const contactBody = {
      nomCompte: this.detail?.visit_customer || '', // Raison sociale du client
      civilite: 'M.', // Valeur par défaut
      prenom: this.extractFirstName(contactData.contact_fullname),
      nom: this.extractLastName(contactData.contact_fullname),
      telephoneMobile: contactData.contact_phone || '',
      email: contactData.contact_email || '',
      fonctionContact: contactData.contact_function || '',
      // Champs optionnels avec valeurs par défaut
      telephoneDomicile: '',
      telephoneAutre: '',
      serviceContact: '',
      responsableHierarchique: '',
      originePiste: '',
      langue: '',
      adresseRue: '',
      codePostal: '',
      ville: '',
      pays: '',
      autreAdresseRue: '',
      autreCodePostal: '',
      autreVille: '',
      autrePays: '',
      quitterSociete: false,
      invalideContact: false,
      garderContact: true,
      description: `Contact ajouté lors de la visite ${this.detail?.visit_code || ''}`,
      owner: this.connectedComany
    };

    // Appeler le service pour créer le contact
    this.contactService.createNewContact(contactBody);
    
    // S'abonner à la réponse
    this.contactService.newContactSubject.subscribe(
      (response: any) => {
        if (response.code === 'c59967b3cda245c5a5e54eae0ef613d0') { // Code succès          
          // Recharger les contacts du client pour les futures suggestions
          this.loadCustomerContacts();
          
          // Afficher un message de confirmation
          this.showContactAddedMessage(contactData.contact_fullname);
        } else if (response.code === '3bc8e324433c474e8eb7d3d8ea18918d') {
          // Contact déjà existant - on peut ignorer
          console.log('Ce contact existe déjà pour ce client');
        }
      },
      (error: any) => {
        console.error('Erreur lors de la création du contact:', error);
      }
    );
  }

  extractFirstName(fullname: string): string {
    if (!fullname) return 'Prénom';
    const parts = fullname.trim().split(' ');
    return parts[0] || 'Prénom';
  }

  extractLastName(fullname: string): string {
    if (!fullname) return 'Nom';
    const parts = fullname.trim().split(' ');
    if (parts.length > 1) {
      return parts.slice(1).join(' ');
    }
    return parts[0] || 'Nom';
  }

  showContactAddedMessage(contactName: string): void {
    // Utiliser une alerte temporaire comme dans votre code
    const message = `Le contact "${contactName}" a été automatiquement ajouté à la liste des contacts du client.`;
    
    // Vous pouvez réutiliser votre système d'alertes existant
    $('#visit_terminated').text(message);
    $('#visit_terminated').show();
    setTimeout(() => {
      $('#visit_terminated').hide();
    }, 4000);
  }

  addPic(event :any) {
    const imgWrap = document.querySelector('.upload__img-wrap');
    const files = event.target.files;
    const glob =this;
  
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!file.type.match('image.*')) continue;
        this.imgArray.push(file);
  
      const reader = new FileReader();
      reader.onload = function(e) {
        var imgBox = "<div class='upload__img-box'><div style='background-image: url(" + e.target?.result + ")' data-number='" + $(".upload__img-close").length + "' data-file='" + file.name + "' class='img-bg'><div class='upload__img-close'></div></div></div>";

        if (imgWrap) {
          imgWrap.innerHTML += imgBox;
          if (glob.picturesVisit == undefined || glob.picturesVisit == null) {
            glob.picturesVisit =[]
          }
          glob.picturesVisit?.push(e.target?.result);
        }
      };
  
      reader.readAsDataURL(file);
    }
  }
  isContactSelected: boolean = false;
  onContactSelected() {
    this.isContactSelected = true;
    setTimeout(() => {
      this.isContactSelected = false; 
    }, 8000); 
  }
  Detail(id:any){
    this.perso =[];
    this.terminer_plan=true;
    this.visitService.getDetail(id);
    this.visitService.detailSubject.subscribe(
      ( data: any ) => {
        this.terminer_plan=false;        
        if(data.code =="9ee6b80261f5935fcdc9848ac558b605"){
          this.detail= data.visit;
                    
          this.loadCustomerContacts();

          this.selectedContact = data.visit.selected_email??"";
          if(data.visit.contacted_persons !== undefined && data.visit.contacted_persons !== null)this.sells =  data.visit.contacted_persons;
          this.picturesVisit = data.visit.picturesVisit;
          // Display existing pictures
          const imgWrap = document.querySelector('.upload__img-wrap');
          if (imgWrap) {
              this.picturesVisit?.forEach((pictureUrl, index) => {
                  const imgBox = `<div class='upload__img-box'><div style='background-image: url(data:image/png;base64,${pictureUrl})' data-number='${index}' class='img-bg'><div class='upload__img-close'></div></div></div>`;
                  imgWrap.innerHTML += imgBox;
              });
          }
          this.msSector.getSector(this.msToken,this.detail?.visit_customer_sector).subscribe(
            (sectorLabel: any) => {
              this.detail.customer_sector = sectorLabel.label;
            },
            (error) => {
              console.log(error);
            }
          );
          this.perso= data.visit.actions;
          
          for(var ac of this.perso){
            var adaptedAction = {
              action: ac.action,
              action_comment: ac.action_comment,
              action_desc: ac.action_desc,
              status:"En cours",
              new:false
            }
            
            if(ac.action_status!=null){
              adaptedAction.status=ac.action_status;
            }
            this.adaptedActions.push(adaptedAction);
          }
          
          this.perso = this.adaptedActions;
        }
      },
    )  
  }

  verifylenght(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/5000</span>";
      if(len<=5000){
        $("#lenght-"+event.target.id).html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#lenght-"+event.target.id).html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#lenght-"+event.target.id).html("<span style='color:green'><span>0/5000</span></span>");
    }
  }

  removeAddedAction(uuid:any,list:any[]){
    let index = list.findIndex((d:any) => d.action === uuid);
    list.splice(index, 1);
  }

  verifylenghtNewComment(event: any){
    if(event.target.value.length>0){
      var len:any = event.target.value.length-1;
      let toshowNumber:any = "<span>"+len+"/5000</span>";
      if(len<=5000){
        $("#lenght-newComment").html("<span style='color:green'"+toshowNumber+"</span>");
      }else {
        $("#lenght-newComment").html("<span style='color:red'"+toshowNumber+"</span>");
      }
    }else {
      $("#lenght-newComment").html("<span style='color:green'><span>0/5000</span></span>");
    }
  }

  addNewAction(){
    // var checked = document.querySelector('input[name="statusAction"]:checked')as ;
    if($("#new_action").val()!=null && $("#new_action").val()!=" " 
      && $("#new_action").val()!=undefined && $("#new_action").val()!=""){
      var newAction:any={
        action: getUniqueId(this.togenerateUuid),
        action_comment: $("#new_comment").val(),
        action_desc: $("#new_action").val(),
        status:$("input[type='radio'][name='statusAction']:checked").val(),
        new:true
      };
      this.perso.push(newAction);
      this.togenerateUuid = this.togenerateUuid + 11;
      $("#new_comment").val(null as any);
      $("#new_action").val(null as any);
    }
  }

  existingContact:boolean = false;
  addDetailToFinish() {
  if (this.terminatedVisitForm.valid) {
    const finishVisitFormValues = this.terminatedVisitForm.value;
    
    // Vérifier si le contact existe déjà dans la liste des contacts saisis
    const existingContact = this.sells.find(
      prod => prod.contact_email === finishVisitFormValues.contact_email && finishVisitFormValues.contact_email !== ''
      && finishVisitFormValues.contact_email !== null && finishVisitFormValues.contact_email !== undefined
    );
    if (existingContact) {
      this.existingContact = true;
      setTimeout(() => {
        this.existingContact = false;
      }, 5000);
    } else {
      // Ajouter le contact à la liste des contacts de la visite
      this.sells.push(finishVisitFormValues);
      
      // VÉRIFICATION CRUCIALE : Vérifier si le contact est NOUVEAU (non sélectionné via autocomplete)
      // On considère qu'un contact est "nouveau" si son email n'existe pas dans customerContacts
      const isExistingCustomerContact = this.customerContacts.some(
        contact => contact.email === finishVisitFormValues.contact_email
      );
      
      // Si c'est un nouveau contact (pas dans la liste des contacts du client) ET qu'il a un email,
      // on le crée automatiquement pour le client
      if (!isExistingCustomerContact && 
          finishVisitFormValues.contact_email && 
          finishVisitFormValues.contact_fullname) {
        
        this.createContactForCustomer(finishVisitFormValues);
      }
    }
    
    // Réinitialiser le formulaire
    this.terminatedVisitForm.reset();
    
    // Nettoyer les labels MDL
    setTimeout(() => {
      this.clearContactField();
    }, 50);
  } else {
    this.terminatedVisitForm.markAllAsTouched();
  }
}
  

  removeDetailToFinish(element:any){
    var item1 = this.sells.find(i => i === element);
    var index = this.sells.indexOf(item1);
    if (index !== -1) {
      this.sells.splice(index, 1);
      this.somme =this.somme - (item1.price*item1.product_unit);
      if (this.selectedContact === item1.contact_email) {
        this.selectedContact = '';
        this.isContactSelected = false;
      }
    }
  }
  updateStatus(action: any, status: string) {
    action.status = status;
}

  selectedContact!: string;
  terminateVisit(mode:any){
    this.toComplete = mode=='save'? false:true;
    $("html, body").animate({scrollTop:0});
    this.terminer_plan = true;
    for(var act of this.perso){
      var comment = document.getElementById(act.action) as HTMLTextAreaElement;
      
      var commentedaction = {
        "action": act.action,
        "action_desc": act.action_desc,
        "action_comment":comment.value,
        "action_status":act.status
      } 
      this.finalactions.push(commentedaction);
    }
    var body:any ={};
    body = {
      actions : this.finalactions,
      contacts : this.sells,
      pictures : this.picturesVisit,
      selected_email :this.selectedContact
    };
    
    this.dashboardServiceservice.bodyFinish = body;
    this.dashboardServiceservice.terminateVisit(this.id,mode);
    this.dashboardServiceservice.startVisitSubject.subscribe(
    ( data: any ) => {
      this.terminer_plan = false;
      if(data.code =="fe01fa6623c3648dcd4e15c482a2d602"){

        this.addedMsg = this.toComplete ? "Terminée avec succès" : "sauvegardée comme brouillon";
        $("#visit_terminated").show();
        $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
        });
        setTimeout(()=>{
          $("#visit_terminated").hide();
        }, 2000);
          if(this.selectedContact!='')this.initSurveyVisit();
      }else{
        $("#visit_not_terminated").show();
          $('.alert-gradient').removeClass().addClass('fadeIn animated alert alert-gradient ').one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function(){
          });
          setTimeout(()=>{
            $("#visit_not_terminated").hide();
          }, 2000);
      }
    })
  }

  requestBody = {};
  APIToken:any = '';

  initSurveyVisit(){
    const selectedContactInfo = this.sells.find(prod => prod.contact_email === this.selectedContact);

    this.requestBody = {
      uuid_visit: this.id,
      contact_email: this.selectedContact,
      contact_fullName: selectedContactInfo?.contact_fullname,
      connected_company: this.connectedComany
    };

    this.msSurvey.initSurveyVisit(this.requestBody);
    this.msSurvey.initSurveyVisitSubject.subscribe(
      ( data: any ) => {
        this.stepBack();
      },
      (error: any) => {
        this.stepBack();
      }
    )
  }

  stepBack(){
    this.location.back();
  }

  salesData: any[] = [];
  loadingListSales:boolean =false;
  getSalesVisit(){
    this.loadingListSales = true;    
    this.salesSubscription = this.salesService.getSalesOfVisit(this.id).subscribe(
      (data: any) => {    
        this.salesData = data.sales;
        this.loadingListSales = false    
        if(data.code == "cf0e0d96d99d8cd08b9f74c6dd7c1bb8"){          
          this.loadingListSales = false
        }       
        // this.initializeDataTable();
      },
      (error:any) => {
        console.log(error);
        this.loadingListSales = false  
      }
    );
  }
  /**
   * Formater un nombre pour l'affichage
   */
  formatNumber(value: number): string {
    if (value === 0 || value == null) return '0.00';
    return value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }
}
